import {
  Battery,
  BrushCleaning,
  Fan,
  Fingerprint,
  HandMetal,
  HardDrive,
  HdmiPort,
  HeartPulse,
  Keyboard,
  LaptopMinimalCheck,
  LockOpen,
  MapPin,
  Signal,
  SquareCheck,
  Video,
  Volume2,
  Webcam,
  Wifi,
  ZodiacAquarius,
} from 'lucide-react';

const SMARTPHONES_TABLETS_CHECKPOINTS = [
  {
    icon: SquareCheck,
    title: '100% Functional',
  },
  {
    icon: Battery,
    title: 'Battery Health',
  },
  {
    icon: LaptopMinimalCheck,
    title: 'Screen & Display',
  },
  {
    icon: HandMetal,
    title: 'Touch Responsiveness',
  },
  {
    icon: Fingerprint,
    title: 'Face ID & Fingerprint',
  },
  {
    icon: Webcam,
    title: 'Camera Lenses & Sensors',
  },
  {
    icon: Volume2,
    title: 'Audio Input/Output',
  },
  {
    icon: Wifi,
    title: 'Wi-Fi & Bluetooth',
  },
  {
    icon: Keyboard,
    title: 'Physical Buttons',
  },
  {
    icon: HdmiPort,
    title: 'Charging & Other Ports',
  },
  {
    icon: Video,
    title: 'Video & Flash',
  },
  {
    icon: ZodiacAquarius,
    title: 'Vibration & Haptics',
  },
  {
    icon: Signal,
    title: 'Cellular Connectivity',
  },
  {
    icon: LockOpen,
    title: 'Account & Carrier Locks',
  },
  {
    icon: BrushCleaning,
    title: 'Secure Data Wipe',
  },
];

const LAPTOPS_CHECKPOINTS = [
  {
    icon: SquareCheck,
    title: '100% Functional',
  },
  {
    icon: Battery,
    title: 'Battery Health',
  },
  {
    icon: LaptopMinimalCheck,
    title: 'Screen & Display',
  },
  {
    icon: HandMetal,
    title: 'Touch Responsiveness',
  },
  {
    icon: Fingerprint,
    title: 'Face ID & Fingerprint',
  },
  {
    icon: Webcam,
    title: 'Camera Lenses & Sensors',
  },
  {
    icon: Volume2,
    title: 'Audio Input/Output',
  },
  {
    icon: Wifi,
    title: 'Wi-Fi & Bluetooth',
  },
  {
    icon: Keyboard,
    title: 'Physical Buttons',
  },
  {
    icon: HdmiPort,
    title: 'Charging & Other Ports',
  },
  {
    icon: Fan,
    title: 'Cooling Fan Function',
  },
  {
    icon: HardDrive,
    title: 'Hard Drive Health',
  },
  {
    icon: BrushCleaning,
    title: 'Secure Data Wipe',
  },
];

const SMARTWATCHES_CHECKPOINTS = [
  {
    icon: SquareCheck,
    title: '100% Functional',
  },
  {
    icon: Battery,
    title: 'Battery Health',
  },
  {
    icon: LaptopMinimalCheck,
    title: 'Screen & Display',
  },
  {
    icon: HandMetal,
    title: 'Touch Responsiveness',
  },
  {
    icon: ZodiacAquarius,
    title: 'Vibration & Haptics',
  },
  {
    icon: Volume2,
    title: 'Audio Input/Output',
  },
  {
    icon: Wifi,
    title: 'Wi-Fi & Bluetooth',
  },
  {
    icon: Keyboard,
    title: 'Physical Buttons',
  },
  {
    icon: HdmiPort,
    title: 'Charging & Other Ports',
  },
  {
    icon: Signal,
    title: 'Cellular Connectivity',
  },
  {
    icon: HeartPulse,
    title: 'Health Sensors',
  },
  {
    icon: MapPin,
    title: 'GPS & Location Accuracy',
  },
  {
    icon: BrushCleaning,
    title: 'Secure Data Wipe',
  },
];

export const CHECKPOINTS_BY_CATEGORY: Record<
  string,
  { icon: React.ElementType; title: string }[]
> = {
  Smartphones: SMARTPHONES_TABLETS_CHECKPOINTS,
  Tablets: SMARTPHONES_TABLETS_CHECKPOINTS,
  Laptops: LAPTOPS_CHECKPOINTS,
  Smartwatches: SMARTWATCHES_CHECKPOINTS,
};
